import { Form, message, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clienteAxios from '../../../../../config/axios';
import classes from '../../../../pages/Reportes/Ventas/ReporteBalance/ListaReporteBalance.module.css';

const { Option } = Select;

const FormItemSelectBranches = ({
    formInstance,
    formItemProps,
    selectProps,
    disabled,
    initialValue,
    franchiseId,
}) => {
    const [loading, setLoading] = useState(false);
    const [sucursales, setSucursales] = useState();
    const [formItemInitialValue, setFormItemInitialValue] = useState(null);

    useEffect(() => {
        obtenerSucursales();
    }, [franchiseId]);

    useEffect(() => {
        if (initialValue)
            setFormItemInitialValue({ sucursalId: initialValue.toString() });
    }, [initialValue]);

    useEffect(() => {
        formInstance.setFieldsValue(formItemInitialValue);
    }, [formItemInitialValue]);

    // Formulario - Obtener datos
    const obtenerSucursales = async () => {
        const params = { franchise_id: franchiseId?.toString() || undefined };

        setLoading(true);
        try {
            const response = await clienteAxios.get('/branches_list', {
                params,
            });
            setSucursales(response?.data?.data?.branches);
        } catch (error) {
            message.error(
                error.response?.data.message ||
                    'Hubo un problema al obtener la lista de sucursales',
            );
        }
        setLoading(false);
    };

    return (
        <Form.Item
            name="branchId"
            label="Sucursal"
            {...formItemProps}
            className={classes.filters}
            defaultValue="Todas">
            <Select
                {...selectProps}
                disabled={disabled || loading}
                showSearch
                allowClear
                optionFilterProp="children"
                filterOption={(input, option) =>
                    option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                }>
                {sucursales &&
                    sucursales.map((item) => (
                        <Option key={item.branch_id} value={item.branch_id}>
                            {item.name}
                        </Option>
                    ))}
            </Select>
        </Form.Item>
    );
};

export default FormItemSelectBranches;

FormItemSelectBranches.propTypes = {
    formItemProps: PropTypes.any,
    selectProps: PropTypes.any,
    formInstance: PropTypes.instanceOf(Form),
    disabled: PropTypes.bool,
    initialValue: PropTypes.object,
    franchiseId: PropTypes.any,
};
